const topVideo = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {
    ScrollTrigger.create({
      trigger: ".ldk_wrap2 ",
      // markers: true,
      start: "top center",
      once: true,
      onEnter: self => {
        planilani1();
      },
      toggleClass: {targets: ".ldk_wrap2 ", className: "ani1"},
    })
    function planilani0(){
      document.querySelector('.ldk_wrap2').classList.add("ani1b");
      document.querySelector('.ldk_wrap2').classList.remove("ani1");
      document.querySelector('.ldk_wrap2').classList.remove("ani2");
      document.querySelector('.ldk_wrap2').classList.remove("ani3");
      document.querySelector('.ldk_wrap2').classList.remove("ani4");

      setTimeout(function () {
        document.querySelector('.ldk_wrap2').classList.add("ani1");
        planilani1();
      }, 900);
    }
    function planilani1(){
      setTimeout(function () {
        document.querySelector('.ldk_wrap2').classList.add("ani2");
      }, 900);
      setTimeout(function () {
        document.querySelector('.ldk_wrap2').classList.add("ani3");
      }, 900 + 900);
      setTimeout(function () {
        document.querySelector('.ldk_wrap2').classList.add("ani4");
      }, 900 + 1800);
      // setTimeout(function () {
      //   planilani0();
      // }, 900 + 1800 + 5000);
    }
  }
})();
export default topVideo;